import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBKovcrtNqpjZSRI03iLMAG7DLRlJKWZzQ",
  authDomain: "molaturknet.online",
  databaseURL: "https://mola-sirasi-tn-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "mola-sirasi-tn",
  storageBucket: "mola-sirasi-tn.firebasestorage.app",
  messagingSenderId: "755405777577",
  appId: "1:755405777577:web:f355ce4e354bd8f629d7b8"
};

const app = initializeApp(firebaseConfig);
export const database = getDatabase(app);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();